import React from "react";
import HowToBeLaunchified from "../components/HomePage/HowToBeLaunchified/HowToBeLaunchified";
import { motion } from "framer-motion";
import HomeCarousel from "../components/HomePage/HomeCarousel/HomeCarousel";
import WhyLaunchified2 from "../components/HomePage/WhyLaunchified2/WhyLaunchified2";
//import LaunchyChatBot from "../components/ChatBot/chatbot";
function Home() {
  return (
    <div>
      <motion.div
        initial={{ y: "-100vh", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <div>
          <HomeCarousel />
        </div>
        <div>
          <WhyLaunchified2 />
        </div>
        <div>
          <HowToBeLaunchified />
        </div>
        <div>{/* <LaunchyChatBot /> */}</div>
      </motion.div>
    </div>
  );
}

export default Home;
